// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"adcd3665","645":"34b608cb"}[chunkId] + ".chunk.css";
};